import { gql } from '@apollo/client'

export const GET_ALL_SURVEYS_QUESTION_TYPE = gql`
  query GetAllSurveyQuestionType(
    $searchQuery: String
    $limit: Int
    $offset: Int
  ) {
    getAllSurveyQuestionType(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
    ) {
      count
      rows {
        id
        name
        key
        description
      }
    }
  }
`
